import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import star from "../../assets/star.png";
import icon1 from "../../assets/icon1.png";
import icon2 from "../../assets/icon2.png";
import icon3 from "../../assets/icon3.png";
import icon4 from "../../assets/icon4.png";
import icon5 from "../../assets/icon5.png";
import icon6 from "../../assets/Icon6.png";
import featureMob from "../../assets/featureMob.png";

const cardArray = [icon4, icon5, icon6, icon1, icon2, icon3];

const Feature = () => {
  return (
    <Box
      py={2}
      sx={{
        background: `url(${star}), #021B33`,
        backgroundSize: "100% 100%",
        height: "100%",
        minHeight: "100vh",
        backgroundRepeat: "no-repeat",
        paddingBottom: "7rem",
      }}
    >
      <Container>
        <Typography
          varaint="h3"
          sx={{
            fontSize: { xs: "25px", md: "40px" },
            fontWeight: "400",
            fontFamily: "Zen Dots",
            color: "white",
          }}
        >
          FEATURES & APPLICATIONS
        </Typography>

        <Box py={5}>
          <Grid container spacing={4}>
            <Grid item md={6} xs={12}>
              <Grid container spacing={2}>
                {cardArray.map((item, i) => {
                  return (
                    <Grid item md={6} sm={6} xs={12}>
                      <Box
                        sx={{
                          boxShadow: "0px 3.2px 10px rgba(0, 0, 0, 1)",
                          borderRadius: "12px",
                          padding: "1rem",
                          display: "flex",
                          justifyContent: "space-between",
                          // background:
                          //   " linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                          //   opacity: 0.1,
                        }}
                      >
                        <img
                          src={item}
                          width="40px"
                          height="40px"
                          alt="abc"
                          style={{
                            background:
                              " linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                          }}
                        />
                        <Box color="white" ml={2}>
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontWeight: "600",
                              fontFamily: "Inter",
                              marginBottom: "10px",
                            }}
                          >
                            Buy and sell items easily
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: "400",
                              fontFamily: "Inter",
                              color: "#D9D9D9",
                            }}
                          >
                            - As soon as our artists finish their magnum opus,
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: "400",
                              fontFamily: "Inter",
                              color: "#D9D9D9",
                            }}
                          >
                            - The Alpha Kongs Club opens its gates to an
                            exclusive guest
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <img src={featureMob} alt="featureMob" srcset="" width="100%" />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Feature;
